import React from "react"

import { FormContactsType } from "~/api/types/FormwithcontactsList"
import { Card } from "~/components/Card/Card"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"

import styles from "./index.module.css"

export const CardWrapper: React.FC<FormContactsType> = ({
  name,
  comment,
  email,
  phone,
  linkUrl,
  linkText,
}) => {
  return (
    <Card className={styles.Wrapper}>
      <div className={styles.Bio}>
        <Heading as="div" like="h2">
          <Raw html={name} />
        </Heading>

        {comment && <div dangerouslySetInnerHTML={{ __html: comment }} />}
      </div>

      <div className={styles.Contacts}>
        {phone && (
          <div className={styles.Phone}>
            <a dangerouslySetInnerHTML={{ __html: phone }} href={`tel:${phone}`} />
          </div>
        )}

        {email && (
          <div className={styles.Email}>
            <a dangerouslySetInnerHTML={{ __html: email }} href={`mailto:${email}`} />
          </div>
        )}
      </div>

      {linkText && linkUrl && (
        <Link className={styles.WebSiteLink} href={linkUrl} view="arrow">
          <Raw html={linkText} />
        </Link>
      )}
    </Card>
  )
}
